import { useRef, useEffect, useCallback, memo } from 'react';

const width=200;
const height=108;
const limitNum=8;
const gap=8.9;
const topGap = 10;
const step = 10;
const bottomGap = 20;
const capR=2;
const meterWidth=15;
const arcColor="#07F2F3";

const AiEm = memo((props) => {
    const {
        data=[],
        checkedAiEm,
        setCurrentAiEm,
        isAiEm,
    } = props;
    const canvasRef = useRef();
    const mouseOverIndex = useRef(-1);
    const checkedEm = useRef(null);
    const currentEm = useRef(null);
    const emData = useRef([]);
    const dataAry = useRef([]);
    const animationTimer = useRef(null);
    const lastFramePos = useRef(0);
    // console.log(emData.current.map(ele => `${ele.newKeyNote}${ele.newScale}=${ele.count}=${ele.value}`));
    // console.log(dataAry.current.map(ele => `${ele.newKeyNote}${ele.newScale}=${ele.count}=${ele.value}`));

    useEffect(() => {
        // console.log(dataAry.current.map(ele => `${ele.newKeyNote}${ele.newScale}=${ele.count}=${ele.value}`));
        // console.log(emData.current.map(ele => `${ele.newKeyNote}${ele.newScale}`));
        if (data && data.framePos) {
            const temp = JSON.parse(JSON.stringify(emData.current));
            const index = temp.findIndex(ele => {
                return ele.index === data.index;
            })
            const diff = data.framePos - lastFramePos.current;
            // console.log(`${data.framePos}-${lastFramePos.current}=${diff}`);
            if (index !== -1) {
                temp[index].count = temp[index].count + diff;
            } else {
                temp.push(Object.assign(data, {count: diff}));
            }
            lastFramePos.current = data.framePos;
            emData.current = temp;
        } else {
            lastFramePos.current = 0;
            currentEm.current = null;
            checkedEm.current = null;
            dataAry.current = [];
            emData.current = [];
            if (canvasRef.current) {
                const ctx = canvasRef.current.getContext('2d');
                ctx.clearRect(0, 0, width, height);
            }
        }
    }, [data])
    useEffect(() => {
        if (!animationTimer.current) {
            draw();
        }
    });

    const transition = (startAry, targetAry, increment = 10000) => {
        const result = [];
        let isComputed = true;
        for (let i = 0; i < targetAry.length; i++) {
            const index = startAry.findIndex(ele => ele.index === targetAry[i].index)
            if (index !== -1) {
                const value = startAry[index].value + 1;
                if (targetAry[i].count - startAry[index].count >= increment) {
                    result.push(Object.assign({}, targetAry[i], {count: startAry[index].count + increment, value: value}));
                    isComputed = false;
                } else if (targetAry[i].count - startAry[index].count <= 0) {
                    result.push(Object.assign({}, startAry[index]));
                } else {
                    isComputed = false;
                    result.push(Object.assign({}, targetAry[i], {value: value}));
                }
            } else {
                const count = (targetAry[i].count < increment) ? targetAry[i].count : increment;
                result.push(Object.assign({}, targetAry[i], {count: count, value: 5 }));
                isComputed = false;
            }
        }
        result.sort((a, b) => {
            return b.count - a.count;
        })
        result.forEach((ele, i) => {
            let max = height - bottomGap - topGap - i * step;            
            max = max < step ? step : max;
            if (ele.value > max) {
                ele.value = max
            }
        });
        return {
            result: result,
            isComputed: isComputed,
        }
    }
    const drawOnce = useCallback((ctx, ary) => {
        // if (window.devicePixelRatio) {
            // width = width * window.devicePixelRatio
            // height = height * window.devicePixelRatio
            // ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
        // }
        const meterGapWidth = meterWidth + gap;
        ctx.clearRect(0, 0, width, height);
        for (let i = 0; i < ary.length; i++) {
            if (i >= limitNum) {
                break;
            }
            const value = ary[i].value;
            const x = width - i * meterGapWidth - meterGapWidth;
            const y = height - value - bottomGap;
            ary[i].x = x;
            ary[i].y = y;
            if (ary[i].isMinor) {
                ctx.beginPath();
                ctx.arc(x + meterWidth/2, y - 5, capR, 0, 2 * Math.PI);
                ctx.fillStyle = arcColor;
                ctx.fill();
            }
            ctx.fillStyle = ary[i].color;
            ctx.fillRect(x, y, meterWidth, value);
            ctx.font = "12px Microsoft YaHei";
            const text = ary[i].newKeyNote.length < 2 ? ` ${ary[i].newKeyNote}` : ary[i].newKeyNote
            ctx.fillText(text, x, height - 5);
            // if (checkedEm.current) {
            //     ctx.fillStyle = "#07f2f3";
            //     ctx.fillText(checkedEm.current.newScale, 26, 40);
            //     ctx.fillStyle = "#ffffff";
            //     ctx.font = "19px Microsoft YaHei";
            //     ctx.fillText(checkedEm.current.newKeyNote, 14, 24);
            // } else if (currentEm.current) {
            //     ctx.fillStyle = "#07f2f3";
            //     ctx.fillText(currentEm.current.newScale, 26, 40);
            //     ctx.fillStyle = "#ffffff";
            //     ctx.font = "19px Microsoft YaHei";
            //     ctx.fillText(currentEm.current.newKeyNote, 14, 24);
            // }
            if (mouseOverIndex.current === i || (checkedEm.current && checkedEm.current.index === ary[i].index)) {
                ctx.lineWidth = 2;
                ctx.strokeStyle = "#ffffff";
                ctx.strokeRect(x, y, meterWidth, value);
                ctx.strokeStyle = "#07f2f3";
                ctx.strokeRect(x - 2, y - 2, meterWidth + 4, value + 4);
            }
        }
    }, [])
    const draw = () => {
        if (!canvasRef.current) {
            return;
        }
        const ctx = canvasRef.current.getContext('2d');
        const drawBar = () => {
            const { result, isComputed } = transition(dataAry.current, emData.current);
            dataAry.current = JSON.parse(JSON.stringify(result));
            if (dataAry.current.length) {
                if (!currentEm.current || (currentEm.current && currentEm.current.index !== dataAry.current[0].index)) {
                    currentEm.current = {
                        newKeyNote: dataAry.current[0].newKeyNote,
                        newScale: dataAry.current[0].newScale,
                        musicKeynote: dataAry.current[0].musicKeynote,
                        type: dataAry.current[0].type,
                        index: dataAry.current[0].index,
                    };
                    if (!checkedEm.current) {
                        setCurrentAiEm({
                            newKeyNote: dataAry.current[0].newKeyNote,
                            newScale: dataAry.current[0].newScale,
                            musicKeynote: dataAry.current[0].musicKeynote,
                            type: dataAry.current[0].type,
                        })
                    }
                }
            }
            if (isComputed) {
                clearTimeout(animationTimer.current);
                animationTimer.current = null;
                return
            }
            drawOnce(ctx, dataAry.current)
            animationTimer.current = setTimeout(() => {
                drawBar();
            }, 100)
        }
        drawBar()
    }

    const getItemIndex = (e) => {
        const rect = canvasRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        // const y = e.clientY - rect.top;
        let index = -1;
        for (let i = 0; i < dataAry.current.length; i++) {
            const bar = dataAry.current[i];
            if (x >= bar.x && x <= bar.x + meterWidth) {
                index = i;
            }
        }
        return index;
    }
    const handleClickEm = (e) => {
        const index = getItemIndex(e);
        if (index === -1 || !isAiEm) {
            if (checkedEm.current) {
                checkedAiEm({
                    musicKeynote: checkedEm.current.musicKeynote,
                    newKeyNote: checkedEm.current.newKeyNote,
                    newScale: checkedEm.current.newScale,
                    type: checkedEm.current.type,
                })
            } else if (currentEm.current) {
                checkedAiEm({
                    musicKeynote: currentEm.current.musicKeynote,
                    newKeyNote: currentEm.current.newKeyNote,
                    newScale: currentEm.current.newScale,
                    type: currentEm.current.type,
                })
            }
            return
        }
        checkedEm.current = {
            newKeyNote: dataAry.current[index].newKeyNote,
            newScale: dataAry.current[index].newScale,
            musicKeynote: dataAry.current[index].musicKeynote,
            type: dataAry.current[index].type,
            index: dataAry.current[index].index,
        }
        checkedAiEm({
            musicKeynote: checkedEm.current.musicKeynote,
            newKeyNote: checkedEm.current.newKeyNote,
            newScale: checkedEm.current.newScale,
            type: checkedEm.current.type,
        })
        setCurrentAiEm({
            musicKeynote: checkedEm.current.musicKeynote,
            newKeyNote: checkedEm.current.newKeyNote,
            newScale: checkedEm.current.newScale,
            type: checkedEm.current.type,
        })
        const ctx = canvasRef.current.getContext('2d');
        drawOnce(ctx, dataAry.current);
    }
    const handleMouseMove = (e) => {
        mouseOverIndex.current = getItemIndex(e);
        if (mouseOverIndex.current !== -1 && canvasRef.current) {
            const ctx = canvasRef.current.getContext('2d');
            drawOnce(ctx, dataAry.current);
        }
    }
    const handleMouseLeave = () => {
        mouseOverIndex.current = -1;
        if (canvasRef.current) {
            const ctx = canvasRef.current.getContext('2d');
            drawOnce(ctx, dataAry.current);
        }
    }

    return (
        <canvas onClick={handleClickEm} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} ref={canvasRef} width={width} height={height}></canvas>
    )
})

export default AiEm
